// import logoBlackSvg from "../assets/images/logo_black.svg";
import logoBlack from "../assets/images/logo_black.png";

import "../assets/css/product.scss";

function Footer() {
  return (
    <div className="product-footer">
      <ul>
        <li>
          <div className="logo">
            <img src={logoBlack} alt="" />
          </div>
          <ul>
            <li>상호&nbsp;|&nbsp;주식회사 위고컴퍼니</li>
            <li>
              <a href="/application/service" target="_blank" rel="noreferrer">
                이용약관
              </a>
              &nbsp;|&nbsp;
              <a href="/application/privacy" target="_blank" rel="noreferrer">
                개인정보처리방침
              </a>
            </li>
          </ul>
          <ul>
            <li>대표자 성명&nbsp;|&nbsp;김영기</li>
            <li>청소년보호책임자&nbsp;|&nbsp;김준영</li>
          </ul>
          <ul>
            <li>
              사업장 소재지(도로명주소)&nbsp;|&nbsp;경기도 화성시 동탄대로5길 21
              4층 E420-A26호 (송동, 라크몽)
            </li>
            <li>사업자등록번호&nbsp;|&nbsp;339-87-00990</li>
            <li>대표전화&nbsp;|&nbsp;02-3288-3455</li>
          </ul>
          <ul>
            <li>제호&nbsp;|&nbsp;키즈다</li>
          </ul>
          <ul>
            <li>통신판매업등록번호&nbsp;|&nbsp;2021-화성동탄-0946</li>
          </ul>
        </li>
        <li>Copyright by 키즈다 All rights reserved</li>
      </ul>
    </div>
  );
}

export default Footer;
